/**
 * Simple toast notification hook
 */
export interface ToastConfig {
  title?: string;
  description?: string;
  variant?: 'default' | 'destructive';
}

export function useToast() {
  const toast = (_config: ToastConfig | string) => {
    // Toast notifications are handled by the UI framework
    // This hook provides the interface for triggering them
  };

  return { toast };
}
